"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableSortLabel.default;
  }
});

var _TableSortLabel = _interopRequireDefault(require("./TableSortLabel"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/TableSortLabel/index.js
 ** module id = 947
 ** module chunks = 0
 **/